const DEFAULT_WIDTH = 220;
const Sidebar = ({ width = DEFAULT_WIDTH, headerSpacing, children }) => {
  const style = {
    height: "100vh",
    width:  `${width}px`
  };
  if (headerSpacing) {
    style.paddingTop = "47px";
  }
  return (
    <div className="d-flex flex-column sticky-top flex-shrink-0 border-end" style={style}>
      <div className="p-3">
        {children}
      </div>
    </div>
  );
};
export default Sidebar;